<svg id="loader" width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <defs>
        <style type="text/css">
            @keyframes fadeOutIn {
                0% {
                    fill-opacity: 1;
                }

                12.5% {
                    fill-opacity: 0;
                }

                50% {
                    fill-opacity: 1;
                }
            }

            g.pixelGroup {
                animation-duration: 1.6s;
                animation-timing-function: steps(1, start);
                animation-iteration-count: infinite;
                animation-name: fadeOutIn;
            }

            g.pixelGroup:nth-child(1) {
                animation-delay: 0s;
            }

            g.pixelGroup:nth-child(2) {
                animation-delay: 0.2s;
            }

            g.pixelGroup:nth-child(3) {
                animation-delay: 0.4s;
            }

            g.pixelGroup:nth-child(4) {
                animation-delay: 0.6s;
            }

            g.pixelGroup:nth-child(5) {
                animation-delay: 0.8s;
            }

            g.pixelGroup:nth-child(6) {
                animation-delay: 1s;
            }

            g.pixelGroup:nth-child(7) {
                animation-delay: 1.2s;
            }

            g.pixelGroup:nth-child(8) {
                animation-delay: 1.4s;
            }
        </style>
    </defs>
    <g stroke="none" stroke-width="1" fill-rule="evenodd">
        <g class="pixelGroup" transform="translate(4.000000, 0.000000)">
            <rect id="Rectangle" x="0" y="0" width="2" height="2"></rect>
            <rect id="Rectangle-Copy-11" x="2" y="0" width="2" height="2"></rect>
        </g>
        <g class="pixelGroup" transform="translate(8.000000, 0.000000)">
            <rect id="Rectangle-Copy-12" x="0" y="0" width="2" height="2"></rect>
            <rect id="Rectangle-Copy-98" x="2" y="2" width="2" height="2"></rect>
        </g>
        <g class="pixelGroup" transform="translate(12.000000, 4.000000)">
            <rect id="Rectangle-Copy-99" x="0" y="0" width="2" height="2"></rect>
            <rect id="Rectangle-Copy-100" x="0" y="2" width="2" height="2"></rect>
        </g>
        <g class="pixelGroup" transform="translate(10.000000, 8.000000)">
            <rect id="Rectangle-Copy-101" x="2" y="0" width="2" height="2"></rect>
            <rect id="Rectangle-Copy-102" x="0" y="2" width="2" height="2"></rect>
        </g>
        <g class="pixelGroup" transform="translate(6.000000, 12.000000)">
            <rect id="Rectangle-Copy-103" x="2" y="0" width="2" height="2"></rect>
            <rect id="Rectangle-Copy-104" x="0" y="0" width="2" height="2"></rect>
        </g>
        <g class="pixelGroup" transform="translate(2.000000, 10.000000)">
            <rect id="Rectangle-Copy-105" x="2" y="2" width="2" height="2"></rect>
            <rect id="Rectangle-Copy-106" x="0" y="0" width="2" height="2"></rect>
        </g>
        <g class="pixelGroup" transform="translate(0.000000, 6.000000)">
            <rect id="Rectangle-Copy-107" x="0" y="2" width="2" height="2"></rect>
            <rect id="Rectangle-Copy-108" x="0" y="0" width="2" height="2"></rect>
        </g>
        <g class="pixelGroup" transform="translate(0.000000, 2.000000)">
            <rect id="Rectangle-Copy-109" x="0" y="2" width="2" height="2"></rect>
            <rect id="Rectangle-Copy-110" x="2" y="0" width="2" height="2"></rect>
        </g>
    </g>
</svg>